/**
 * @generated SignedSource<<63d074d8358322ecb5e2b5b6bd912136>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type UserCellInternal$data = {
  readonly " $fragmentSpreads": FragmentRefs<"UserCellInternal_UserCellInternal">;
  readonly " $fragmentType": "UserCellInternal";
};
export type UserCellInternal$key = {
  readonly " $data"?: UserCellInternal$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCellInternal">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isEditableSyncLoaded"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "UserCellInternal",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isEditableSyncLoaded",
          "variableName": "isEditableSyncLoaded"
        },
        {
          "kind": "Variable",
          "name": "isInlineEditingEnabled",
          "variableName": "isInlineEditingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "UserCellInternal_UserCellInternal"
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "222a689111ce0aec54903a0d814d0501";

export default node;
